import { render, staticRenderFns } from "./ShipmentsReport.vue?vue&type=template&id=3c522849&scoped=true"
import script from "./ShipmentsReport.vue?vue&type=script&lang=js"
export * from "./ShipmentsReport.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsReport.vue?vue&type=style&index=0&id=3c522849&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c522849",
  null
  
)

export default component.exports